module.exports = __webpack_public_path__ + "img/avanzato.73b72b8a.png";